import type { FieldErrorsImpl, FieldValues, UseFormRegister } from 'react-hook-form'

import { Input } from '@/ui/atoms/Input'
import { Icon } from '@/ui/atoms/Icon'
import React from 'react'
import { useFormContext } from 'react-hook-form'
import { cn } from '@/utils/ui'

import { Error } from '../Error'
import { Width } from '../Width'
import { TextField } from '@/payload-types'
import { FormLabel } from '@/ui/atoms/FormLabel'

export const Text: React.FC<
  TextField & {
    errors: Partial<
      FieldErrorsImpl<{
        [x: string]: any
      }>
    >
    register: UseFormRegister<FieldValues>
  }
> = ({
  name,
  defaultValue,
  description,
  icon,
  errors,
  label,
  register,
  required = false,
  width,
}) => {
  const { setValue, watch } = useFormContext()
  const value = watch(name)

  return (
    <Width width={width ?? 100}>
      <div>
        <div className="grid gap-1 mb-2">
          <FormLabel htmlFor={name} description={description}>
            {label}
          </FormLabel>
        </div>
        <div className="relative">
          {icon && (
            <div className="absolute inset-y-0 left-0 flex items-center justify-center w-8">
              <Icon name={icon} className="h-4 w-4 text-text-base" />
            </div>
          )}
          <Input
            id={name}
            type="text"
            placeholder={!value ? defaultValue?.toString() : undefined}
            {...register(name, { required: Boolean(required) })}
            hasError={errors[name] ? true : false}
            className={cn(
              '!text-body-XS-regular text-text-base',
              'placeholder:text-text-faded',
              icon && 'pl-8',
            )}
          />
        </div>
        {errors[name] && <Error />}
      </div>
    </Width>
  )
}
